import * as React from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'
import { createTheme, PaletteColor } from '@mui/material/styles'

declare module "@mui/material/styles" {
  interface Palette {
    upcoming: PaletteColor
  }
  interface PaletteOptions {
    upcoming: PaletteColor
  }
}

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    upcoming: true
  }
}

const LinkBehavior = React.forwardRef<
  any,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props
  // Map href (MUI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />
})

const { palette } = createTheme()

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000'
    },
    secondary: {
      main: '#E1E1E1',
      dark: '#BEBEBE'
    },
    upcoming: palette.augmentColor({
      color: {
        main: '#000000'
      }
    })
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      }
    }
  }
})

theme.typography.h2 = {
  fontSize: '2.2rem',
  '@media (min-width:600px)': {
    fontSize: '3.6rem'
  }
}

theme.typography.h4 = {
  fontSize: '1.6rem',
  '@media (min-width:600px)': {
    fontSize: '2.1rem'
  }
}

theme.typography.h5 = {
  fontSize: '1.0rem',
  '@media (min-width:600px)': {
    fontSize: '1.3rem'
  }
}

export default theme
